import styled from "@emotion/styled";
import { hideScrollbar } from "src/scrollbar";

export const CategoryPillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CategoryPillsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space4};
`;

export const CategoryPillsBack = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space4};
  min-width: 0;
  margin-inline-start: -4px;
  margin-block: -4px;
  padding: 4px;

  svg {
    display: block;
    flex-shrink: 0;
  }
`;

export const CategoryPillsNav = styled.nav`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space8};
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  padding-block: ${({ theme }) => theme.space.space4};
  ${hideScrollbar}
`;

export const CategoryPill = styled.a<{ isActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 40px;
  padding: 0 16px;
  border: 1px solid
    ${({ theme, isActive }) =>
      isActive ? theme.colors.tone.black : theme.colors.tone.silver};
  border-radius: 32px;
  background: transparent;
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
  scroll-snap-align: start;
`;
